export default __webpack_public_path__ + "static/media/logout.d0b6f93a.svg";